/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useTranslation } from 'react-i18next';
import SummaryCard from '../../../common/SummaryCard/SummaryCard';

const useStyles = makeStyles(() => {
  return {
    cardMaxWidth: {
      maxWidth: 'unset',
    },
  };
});

export default function AttachmentsCard({ attachmentEntries, isSummary, readOnly = false, cardTitle }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <SummaryCard
      Icon={AttachFileIcon}
      cardTitle={cardTitle ?? t('attachments.title')}
      cardsubTitle=""
      entries={attachmentEntries}
      sectionName="submission_attachments"
      isSummary={isSummary}
      readOnly={readOnly}
      className={classes}
    />
  );
}
